import { mdiNoteMultipleOutline } from '@mdi/js'

export default {
  title: 'Bank Question',
  to: 'bank-admin',
  icon: mdiNoteMultipleOutline,
  resource: 'BankQuestionAdmin',
  action: 'read',
}
